import {ReactComponent as WorldMap} from '../Assets/world_map.svg'

export {WorldMap}
